import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const FullScreen = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg ref={ref} {...props} viewBox="0 0 18 18">
          <path d="M1 12V17H6M17 12V17H12M12 1H17V6M6 1H1V6" stroke="#0F0F14" />
        </svg>
      </Icon>
    );
  },
);

FullScreen.displayName = "FullScreen";
